import { MonthlyInvoicePanel } from "@/components/organisms";

export const MonthlyInvoice = () => <MonthlyInvoicePanel />;
